module.exports = __webpack_public_path__ + "static/media/Do.ac3c65c1.svg";